import { render, staticRenderFns } from "./rankDetail.vue?vue&type=template&id=0c0fce36&scoped=true&"
import script from "./rankDetail.vue?vue&type=script&lang=js&"
export * from "./rankDetail.vue?vue&type=script&lang=js&"
import style0 from "./rankDetail.vue?vue&type=style&index=0&id=0c0fce36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0fce36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c0fce36')) {
      api.createRecord('0c0fce36', component.options)
    } else {
      api.reload('0c0fce36', component.options)
    }
    module.hot.accept("./rankDetail.vue?vue&type=template&id=0c0fce36&scoped=true&", function () {
      api.rerender('0c0fce36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fude/rank/rankDetail.vue"
export default component.exports